import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroCultureIndexLocationCulture,
  selectMeteorologyAgroCultureIndexLocationForecastDate,
  selectMeteorologyAgroCultureIndexLocationPeriodStart,
  selectMeteorologyAgroCultureIndexLocationPeriodEnd,
  selectMeteorologyAgroCultureIndexLocationStage,
  selectMeteorologyAgroCultureIndexLocationLocationId,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { GetChartsParams } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';

export default function useParams() {
  const culture = useSelector(selectMeteorologyAgroCultureIndexLocationCulture);
  const forecastDate = useSelector(selectMeteorologyAgroCultureIndexLocationForecastDate);
  const periodStart = useSelector(selectMeteorologyAgroCultureIndexLocationPeriodStart);
  const periodEnd = useSelector(selectMeteorologyAgroCultureIndexLocationPeriodEnd);
  const stage = useSelector(selectMeteorologyAgroCultureIndexLocationStage);
  const location = useSelector(selectMeteorologyAgroCultureIndexLocationLocationId);

  const params: GetChartsParams | undefined = useMemo(() => {
    const p = {
      location,
      culture: culture?.name,
      forecastDate,
      periodStart,
      periodEnd,
      stage: stage?.label,
    };
    return Object.values(p).some((param) => param === undefined) ? undefined : p;
  }, [culture, forecastDate, periodStart, periodEnd, stage, location]);

  return params;
}
